import helpers from '../index.js';
export const balance = (caseVouchers, postProcessing) => {
    const newVouchers = helpers.vouchers.postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: postProcessing?.filter?.includeIrrecoverableVouchers || false,
        includeDeletedVouchers: postProcessing?.filter?.includeDeletedVouchers || false,
        includeExpiredVouchers: postProcessing?.filter?.includeExpiredVouchers || false,
    });
    let sum = 0;
    for (const voucher of newVouchers) {
        sum += voucher.amount;
    }
    return sum;
};
export const balanceCategory = (caseVouchers, category, postProcessing) => helpers.vouchers
    .postProcessing(caseVouchers, {
    includeIrrecoverableVouchers: postProcessing?.filter?.includeIrrecoverableVouchers || false,
    includeDeletedVouchers: postProcessing?.filter?.includeDeletedVouchers || false,
    includeExpiredVouchers: postProcessing?.filter?.includeExpiredVouchers || false,
})
    .reduce((acc, voucher) => (voucher.category === category ? voucher.amount : 0) + acc, 0);
export const balanceCategoryWithDistribution = (caseVouchers, category, postProcessing) => helpers.vouchers.postProcessing(caseVouchers, {
    includeIrrecoverableVouchers: postProcessing?.filter?.includeIrrecoverableVouchers || false,
    includeDeletedVouchers: postProcessing?.filter?.includeDeletedVouchers || false,
    includeExpiredVouchers: postProcessing?.filter?.includeExpiredVouchers || false,
}).reduce((acc, caseVouchers) => (caseVouchers.category === category
    ? caseVouchers.amount - caseVouchers.distributionAmount
    : 0) + acc, 0);
export const balanceVoucherType = (caseVouchers, postProcessing, ...typeIds) => {
    const lookup = typeIds.reduce((acc, id) => ({ ...acc, [id]: true }), {});
    return helpers.vouchers
        .postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: postProcessing?.filter?.includeIrrecoverableVouchers || false,
        includeDeletedVouchers: postProcessing?.filter?.includeDeletedVouchers || false,
        includeExpiredVouchers: postProcessing?.filter?.includeExpiredVouchers || false,
    })
        .reduce((acc, caseVouchers) => (lookup[caseVouchers.voucherTypeId] ? caseVouchers.amount : 0) + acc, 0);
};
//# sourceMappingURL=index.js.map